import { inject } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import * as React from 'react';

import { AnalyticsStore, PageStore } from 'bernie-core';
import { Context } from 'bernie-context';

import { CustomerNotification, CustomerNotificationLocation } from '@shared-ui/customer-notifications';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { classNames } from 'uitk-react-utils';

import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

interface CustomerNotificationsProps {
  location: CustomerNotificationLocation;
  page?: PageStore;
  classes?: string;
  regionId?: string;
  startDate?: string;
  endDate?: string;
  context?: Context;
  analytics?: AnalyticsStore;
}

export const CustomerNotifications: React.FC<CustomerNotificationsProps> = inject(
  'page',
  'context'
)(
  React.memo((props: CustomerNotificationsProps) => {
    const { location: notificationLocation, page, classes, regionId, startDate, endDate, context } = props;
    const location = useLocation();

    if (!page || !page.pageId) {
      return null;
    }

    let referer = null;
    if (context?.site?.domain) {
      const { domain } = context.site;
      const search = location.search || '';
      const path = location.pathname || '';
      referer = `https://${domain}${path}${search}`;
    }

    const customerNotificationsClasses = classNames('all-t-padding-two', { [classes]: classes });
    let customerNotificationInputs;

    if (Number(regionId)) {
      customerNotificationInputs = {
        notificationLocation,
        xPageId: page.pageId,
        optionalContext: {
          journeyCriterias: [
            {
              destination: {
                regionId: regionId,
              },
              dateRange: {
                start: startDate,
                end: endDate,
              },
            },
          ],
        },
      };
    } else {
      customerNotificationInputs = {
        notificationLocation,
        xPageId: page.pageId,
      };
    }

    if (notificationLocation === 'FOOTER') {
      return (
        <div className={customerNotificationsClasses} data-stid={'footer-customer-notification'}>
          <SimpleLazyLoadWrapper>
            <CustomerNotification
              inputs={{
                xPageId: page.pageId,
                notificationLocation,
                optionalContext: {
                  referer,
                },
              }}
            />
          </SimpleLazyLoadWrapper>
        </div>
      );
    }

    return (
      <Experiment name={'Lshop_Travel_Advisory'}>
        <ExperimentControl />
        <ExperimentVariant bucket={1}>
          <div className={customerNotificationsClasses}>
            <CustomerNotification inputs={customerNotificationInputs} />
          </div>
        </ExperimentVariant>
      </Experiment>
    );
  })
);
